/**
 * WordPress dependencies
 */
import deprecated from '@wordpress/deprecated';
export default function DropZoneProvider(_ref) {
  let {
    children
  } = _ref;
  deprecated('wp.components.DropZoneProvider', {
    since: '5.8',
    hint: 'wp.component.DropZone no longer needs a provider. wp.components.DropZoneProvider is safe to remove from your code.'
  });
  return children;
}
//# sourceMappingURL=provider.js.map